/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for Comment controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, GetCommentsResponse, CreateCommentRequest, CreateCommentResponse } from "../models";

@Injectable({ providedIn: "root" })
export class CommentService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getComments(entityType: any, entityId: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetCommentsResponse>;
    getComments(entityType: any, entityId: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetCommentsResponse>>;
    getComments(entityType: any, entityId: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetCommentsResponse>>;
    getComments(entityType: any, entityId: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Comment/${entityType}/${entityId}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    createComment(createCommentRequest: CreateCommentRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<CreateCommentResponse>;
    createComment(createCommentRequest: CreateCommentRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CreateCommentResponse>>;
    createComment(createCommentRequest: CreateCommentRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CreateCommentResponse>>;
    createComment(createCommentRequest: CreateCommentRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Comment`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, createCommentRequest, requestOptions);
    }
}
